import { SettingOutlined } from '@ant-design/icons';
import { Button, Checkbox, Col, Popover, Row, Select } from 'antd';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import React, { FC, useState } from 'react';
import { DIMENSION_OPTIONS, SUB_METRIC_OPTIONS } from '@/presentation/pages/traffic/analytics/config';
import { MetricSubType } from '@/proto/metric';
import styles from './index.module.scss';
import { Item } from './item';

export interface IProps {
  token: string;
  metricSubType: MetricSubType;
  timeWindow: number;
}


export const StatisticalDistribution: FC<IProps> = (props: IProps) => {
  const { token, metricSubType, timeWindow } = props;
  const [selectMetricType, setSelectMetricType] = useState<MetricSubType>(MetricSubType.SUB_TYPE_COUNT);
  const [selectKey, setSelectKey] = useState<string[]>([
    DIMENSION_OPTIONS[0].value,
    DIMENSION_OPTIONS[1].value,
    DIMENSION_OPTIONS[2].value]);


  const selectMetricTypeChange = (value: MetricSubType) => {
    setSelectMetricType(value);
  };

  const checBoxChange = (key: CheckboxValueType[]) => {
    setSelectKey(key.map(item => String(item)));
  };

  const content = (
    <Checkbox.Group value={selectKey} style={{ width: '100%' }} onChange={checBoxChange}>
      <Row>
        {DIMENSION_OPTIONS.map(item => <Col key={item.value} span={24}>
          <Checkbox value={item.value}>{item.label}</Checkbox>
        </Col>)}
      </Row>
    </Checkbox.Group>
  );

  return <>
    <div className={styles.tool}>
      <span className={styles.cardTitle}>统计分布</span>
      <div>
        <Select onChange={selectMetricTypeChange}
                options={SUB_METRIC_OPTIONS}
                className={styles.metricType}
                value={selectMetricType}/>
        <Popover overlayClassName={styles.popover} placement="bottomRight" content={content} trigger="click">
          <Button className={styles.settingButton} icon={<SettingOutlined />}>设置</Button>
        </Popover>
      </div>
    </div>
  <div className={styles.rankContainer}>

    {DIMENSION_OPTIONS.map((item, index) => {
      if (!selectKey.includes(item.value || '')) {
        return null;
      }
      return <Item
          timeWindow={timeWindow}
        key={index}
        metricName={item.label || ''}
        token={token}
        strokeColor={item.color}
        dimensionName={item.value}
        metricSubType={metricSubType}
        selectMetricType={selectMetricType}
      />;
    })}

  </div>
  </>;
};
